define((require) => {
    "use strict";

    var _                                   = require("underscore"),
        SlideAnimationPropertiesView      = require("ui/experience/widgets/animations/slide/SlideAnimationPropertiesView"),
        SlideOutAnimationPropertiesView     = require("ui/experience/widgets/animations/slideOut/SlideOutAnimationPropertiesView"),
        FadeAnimationPropertiesView       = require("ui/experience/widgets/animations/fade/FadeAnimationPropertiesView"),
        FadeOutAnimationPropertiesView      = require("ui/experience/widgets/animations/fadeOut/FadeOutAnimationPropertiesView"),
        ZoomInAnimationPropertiesView       = require("ui/experience/widgets/animations/zoomIn/ZoomInAnimationPropertiesView"),
        ZoomOutAnimationPropertiesView      = require("ui/experience/widgets/animations/zoomOut/ZoomOutAnimationPropertiesView"),
        MoveAnimationPropertiesView       = require("ui/experience/widgets/animations/move/MoveAnimationPropertiesView");

    /**
     * The different types of animation and information needed by the editor about them.
     *
     * Intentionally split from {@link AnimationTypes} to avoid editor dependencies in the viewer.
     *
     * @class AnimationEditorTypes
     */
    return {
        "SLIDE": {
            id: "slide",
            propertiesViewClass: SlideAnimationPropertiesView
        },
        "SLIDE_OUT": {
            id: "slideOut",
            propertiesViewClass: SlideOutAnimationPropertiesView
        },
        "FADE": {
            id: "fade",
            propertiesViewClass: FadeAnimationPropertiesView
        },
        "FADE_OUT": {
            id: "fadeOut",
            propertiesViewClass: FadeOutAnimationPropertiesView
        },
        "ZOOM_IN": {
            id: "zoomIn",
            propertiesViewClass: ZoomInAnimationPropertiesView
        },
        "ZOOM_OUT": {
            id: "zoomOut",
            propertiesViewClass: ZoomOutAnimationPropertiesView
        },
        "MOVE": {
            id: "move",
            propertiesViewClass: MoveAnimationPropertiesView
        },

        /**
         * Gets the animation type for the given type string.
         *
         * @param {String} typeString The type string.
         * @returns {Object} The type descriptor matching the given type, or undefined if not found.
         */
        fromString: function(typeString) {
            return _.find(this, (type) => {
                return (type.id === typeString);
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/animations/AnimationEditorTypes.js